import { intlDateFormat } from '../../utils/dateUtils';
import { emptyArray } from '../../utils/arrayUtils';

export const V_TAB_VALUES = {
  SUMMARY: 1,
  CONTRACTS: 2,
  TEAMING: 3,
  NOTES: 4,
  GSA: 5,
};

export const V_TABS = [
  { id: 'summary', i18nKey: 'summary', value: V_TAB_VALUES.SUMMARY },
  { id: 'gsa', i18nKey: 'gsa', value: V_TAB_VALUES.GSA, requiresGsa: true },
  { id: 'contracts', i18nKey: 'contracts', value: V_TAB_VALUES.CONTRACTS },
  { id: 'teaming', i18nKey: 'teaming', value: V_TAB_VALUES.TEAMING },
  { id: 'notes', i18nKey: 'notes', value: V_TAB_VALUES.NOTES },
];

export function vendorHasGsaDetails(vendorInfo) {
  const gsaDetails = vendorInfo?.gsaDetails;
  return Boolean(gsaDetails?.hasGsaSchedule && !emptyArray(gsaDetails.gsaContracts));
}

/**
 * GSA vendor detail tab is available in development only.
 * REACT_APP_ENVIRONMENT values mirror backend: dev | test | production.
 */
export function isVendorGsaTabEnabled() {
  const env = String(process.env.REACT_APP_ENVIRONMENT || '').toLowerCase();
  return env === 'dev';
}

export function getVendorDetailTabs(hasGsa) {
  const showGsa = hasGsa && isVendorGsaTabEnabled();
  return V_TABS.filter((tab) => !tab.requiresGsa || showGsa);
}

export const V_MANAGEMENT_DETAILS_TABS = [
  { id: 'summary', i18nKey: 'summary' },
  { id: 'notes', i18nKey: 'notes' },
];

export const V__CONTRACT_TABS = [
  { id: 'funding', i18nKey: 'funding' },
  { id: 'awards', i18nKey: 'awards' },
];

export function getContractAwardId(item) {
  return item && [item.referencedIDVId, item.awardContractId].filter((v) => !!v).join('-');
}

export function nameTypeContact(typeContact) {
  let type = 'Unrecognized';
  if (['governmentBusinessPOC', 'governmentBusinessAlternatePOC'].includes(typeContact)) type = 'Government';
  if (['electronicBusinessPOC', 'electronicBusinessAlternatePOC'].includes(typeContact)) type = 'Electronic';
  if (['pastPerformancePOC', 'pastPerformanceAlternatePOC'].includes(typeContact)) type = 'Performance';

  return type;
}

/** Re-enable year-award chips on /vendors list and quick view. */
export const SHOW_VENDOR_LIST_AWARDS = true;

export const generateLocationShort = (item) =>
  !item.city ? '-' : `${item.city}${item.country ? ', ' + item.country : ''}`;

export const generateLocation = (item) => {
  if (!item.city) return '';

  return [
    item.street || item.addressLine1,
    item.city,
    `${item.state || item.stateOrProvinceCode || ''} ${item.zipCode || ''}`.trim(),
    item.country || item.countryCode,
  ]
    .filter((val) => !!val)
    .join(', ');
};

export const orderOptions = [
  { name: 'RegistrationDate', value: 'registrationDate', asc: 'oldest-first', desc: 'newest-first' },
  { name: 'ActivationDate', value: 'activationDate', asc: 'oldest-first', desc: 'newest-first' },
  {
    name: 'current-year-awards',
    value: 'awardsCurrentYearAmount',
    desc: 'highest-first',
  },
  {
    name: 'previous-year-awards',
    value: 'awardsPreviousYearAmount',
    desc: 'highest-first',
  },
  {
    name: 'previous-5-years-awards',
    value: 'awardsPrevious5YearsAmount',
    desc: 'highest-first',
  },
  {
    name: 'previous-10-years-awards',
    value: 'awardsPrevious10YearsAmount',
    desc: 'highest-first',
  },
  { name: 'relevance', value: 'relevance', desc: 'most' },
];

export const localOrderOptions = [
  { name: 'RegistrationDate', value: 'registrationDate', asc: 'oldest-first', desc: 'newest-first' },
  { name: 'ActivationDate', value: 'activationDate', asc: 'oldest-first', desc: 'newest-first' },
  { name: 'relevance', value: 'relevance', desc: 'most' },
];

export const getRegistrationDate = (registrationDate) => {
  const now = new Date();
  const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

  return currentDate.toISOString() > registrationDate ? intlDateFormat(registrationDate) : null;
};

export const getVendorIdentifiers = (item) => {
  const { dunsCode, ueiCode, cageCode } = item;
  return [dunsCode, ueiCode, cageCode].filter((item) => !!item).join();
};
